import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import { Button } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { FormattedMessage } from "react-intl";
import { Link, useParams } from "react-router-dom";
import { LazyImage } from "../../components/LazyImage";
import { PageError } from "../../components/PageError";
import TableFAQ from "../../components/TableFAQ";
import { useGetDevice } from "../../services/device.service";
import { useGetFaqs, useListCategories } from "../../services/faq.service";

export default function FAQ() {
  const { uid } = useParams();
  const {
    data: device,
    error: errDevice,
    isLoading: isLoadingDev
  } = useGetDevice({ uid });
  const { data: faqs, error, isLoading } = useGetFaqs({ uid });
  const { data: categories, error: errCat, isLoading: isLoadingCat } = useListCategories();

  const isLoadingGeneral = isLoading || isLoadingDev || isLoadingCat;
  const errorGeneral = error && errDevice && errCat;
  const dataGeneral = faqs && device && categories;

  return (
    <>
      {isLoadingGeneral && (
        <div className="page-loading">
          <CircularProgress />
        </div>
      )}
      {!isLoadingGeneral && !!errorGeneral && (
        <div className="page-loading">
          <PageError errorMessage="Error" />
        </div>
      )}
      {dataGeneral && (
        <>
          <div className="bg-[#FFFFFF] shadow-lg min-height-faq-manuals">
            <div className="container mx-auto py-4 px-4">
              <Link to=".." relative="path">
                <Button className="buttons-style" variant="contained">
                  <ArrowCircleLeftIcon className="icon-button" />{" "}
                  <span className="w-full"><FormattedMessage
                id="aftersale_backlink"
                defaultMessage="Torna indietro"
                description="FAQ Torna indietro"
              /></span>
                </Button>
              </Link>
              <div className="grid gap-4 grid-cols-3 grid-rows-1 mt-4">
                <div className="flex items-center">
                  <p className="text-2xl">{device.title}</p>
                </div>
                <div>
                  <LazyImage
                    src={device.assets?.find((one) => one.type === 'device')?.path}
                    alt="Immagine dispositivo"
                  />
                </div>
                <div>
                  <p>
                    <LazyImage
                      src={device.assets?.find((one) => one.type === 'pack')?.path}
                      alt="Immagine packaging"
                    />
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="contenitore-pagina-faq-manuals container mx-auto my-8 px-4">
            <TableFAQ faqs={faqs} categories={categories} />
          </div>
        </>
      )}
    </>
  );
}
